import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import TooltipInfo from './TooltipInfo';
import IconCheck from '../../svg/IconCheck';

function ColumnChecker({ width, isDisabled, trackID, value }) {
  const isReplay = useSelector( state => (state.replayTracks && state.replayTracks.includes(trackID)) );
  return (
    <div className={`type-small column-checker`} style={{ width, textAlign: `center` }}>
      { isDisabled
        ? <TooltipInfo label={'This track is available for download only'} />
        : ((isReplay)
          ? <IconCheck />
          : value
        ) }
    </div>
  )
}

ColumnChecker.propTypes = {
  width: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  trackID: PropTypes.any.isRequired,
  value: PropTypes.any
}

export default ColumnChecker;
